<template>
  <OrderTestDialog
    :is-show-dialog="isVisible"
    :title="title"
    @close="close"
  >
    <p class="subtitle-text">{{ $t("OrderPage[\"Please complete following zoomer bundles in this { itemCategory }:\"]", { itemCategory: itemCategory }) }} </p>
    <div 
      v-for="bundle in xChooseYPanelList" 
      :key="bundle.bundleId" 
      class="mt-3 flex items-center"
    >
      <span v-if="bundle.isComplete" class="material-icons-outlined mr-3 done-icon">check_circle</span>
      <p>{{ bundle.bundleName }}</p>
      <el-button class="ml-3 button" @click="handleSelect(bundle)">{{ $t("OrderPage[\"Select\"]") }}</el-button>
      <XChooseYDialog
        :is-show-dialog="bundle.isOpenXChooseYDialog"
        :title="bundle.bundleName"
        :select-prop="selectProp"
        choose-text="Select zoomers: "
        :test-list="bundle.zoomerList"
        :test-quantity="bundle.quantity"
        :supplementList="bundle.supplementList"
        :supplementQuantity="bundle.supplementQuantity"
        @close="bundle.isOpenXChooseYDialog = false"
        @handleDone="addXChooseYPanel(bundle, $event)"
    />
    </div>
    <el-button class="mt-4 button" @click="done">{{ $t("OrderPage[\"Done\"]") }}</el-button>
  </OrderTestDialog>
</template>

<script>
import XChooseYDialog from "./XChooseYDialog.vue";
import { mapGetters, mapState } from 'vuex';
import { notify } from '@/utils/notify';
import OrderTestDialog from "../components/OrderTestDialog.vue";

export default {
  components: {
    XChooseYDialog,
    OrderTestDialog
  },
  props: {
    isShowDialog: {
      type: Boolean,
      default: false
    },
    title: {
      type: String,
      default: ""
    },
    itemCategory: {
      type: String,
      default: ""
    },
    xChooseYPanelList: {
      type: Array,
      default: () => []
    },
    selectProp: {
      type: String,
      default: "isSelect"
    }
  },
  data() {
    return {
      isVisible: false,
      selectedXChooseYPanelList: []
    }
  },

  watch: {
    isShowDialog(newVal) {
      this.isVisible = newVal;
    }
  },

  computed: {
    ...mapGetters("orderTest/tests", ["testList"]),
    ...mapGetters("orderTest/panels", ["bundleList"]),
  },

  methods: {
    close() {
      this.$emit("close");
    },
    handleSelect(panel) {
      panel.isOpenXChooseYDialog = true;
      panel.zoomerList = this.getZoomerList(panel);
      panel.supplementList = this.getSupplementList(panel);
      // disable zoomer panels and add-ons are already selected before
      // initialize isSelectForXChooseY to default false
      this.selectedXChooseYPanelList.forEach(p => {
        panel.zoomerList.forEach(z => {
          if (p.selectedZoomerIdList && p.selectedZoomerIdList.includes(z.id))
            z[this.selectProp] = true;
        });
        panel.supplementList.forEach(s => {
          if (p.selectedSupplementIdList && p.selectedSupplementIdList.includes(s.id))
            s[this.selectProp] = true;
        });
      });
    },
    getZoomerList(test) {
      let zoomerList = [];
      test.bundleContent.packageList.forEach(p => {
        let foundTest = this.testList.find(test => test.id === p.packageId);
        if (foundTest) {
          foundTest.isSelectForXChooseY = false;
          zoomerList.push(foundTest);
        }
      });
      if (test.quantity === test.bundleContent.packageList.length)
        zoomerList.forEach(zoomer => zoomer.isSelectForXChooseY = zoomer[this.selectProp] ? false : true);
      return zoomerList;
    },

    getSupplementList(panel) {
      let suppList = [];
      let suppPanels = this.bundleList
        .filter(p => panel.supplements.bundleIdList.includes(p.bundleId));
      let suppTests = this.testList
        .filter(t => panel.supplements.packagePriceIdList.includes(t.id));
      suppPanels.concat(suppTests)
        .forEach(s => {
          s.isSelectForXChooseY = false;
          suppList.push(s);
        });
      return suppList;
    },

    addXChooseYPanel(xChooseYPanel, selectedItems) {
      let { selectedTestIdList, selectedSupplementIdList } = selectedItems;
      xChooseYPanel.selectedZoomerIdList = selectedTestIdList;
      xChooseYPanel.selectedSupplementIdList = selectedSupplementIdList;
      xChooseYPanel.isOpenXChooseYDialog = false;
      let index = this.selectedXChooseYPanelList
        .map(panel => panel.bundleId).indexOf(xChooseYPanel.bundleId);
      if (index > -1)
        this.selectedXChooseYPanelList.splice(index, 1, xChooseYPanel);
      else
        this.selectedXChooseYPanelList.push(xChooseYPanel);
      xChooseYPanel.isComplete = true;
    },

    done() {
      if (this.xChooseYPanelList.length !== this.selectedXChooseYPanelList.length) {
        let message = this.$t("OrderPage[\"There are still incomplete zoomer bundles, please complete them first.\"]");
        notify({ type: 'error', message }); 
        return;
      }
      this.$emit("done", this.selectedXChooseYPanelList);
    },
  }
}
</script>

<style scoped>
.button {
  border-radius: 4px;
  background-color: #20A8C3;
  color: #FFFFFF;
  font-family: Roboto;
  font-size: 15px;
  font-weight: 600;
  letter-spacing: 0.43px;
}

.done-icon {
  color: #0ac21f;
}
</style>